import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';
import { SnackBarPayloadModel } from '@shared/models/snack-bar';


export enum SnackBarType {
    Warning = 'warning',
    Success = 'success',
    Error = 'error',
}

/**
 * Push message widget
 */
@Component({
    selector: 'app-snack-bar',
    templateUrl: './snack-bar.component.html',
    styleUrls: ['./snack-bar.component.scss'],
    standalone: true,
    imports: [TranslateModule, MatIconModule],
})
export class SnackBarComponent {
    public readonly snackBarData: SnackBarPayloadModel = inject(MAT_SNACK_BAR_DATA);

    public readonly text: string = this.snackBarData.text;
    public readonly type: string = this.snackBarData.type;

    public readonly snackBarType: typeof SnackBarType = SnackBarType;
}
